module.exports = __webpack_public_path__ + "img/partners14.3c9f91ad.svg";